import { render, staticRenderFns } from "./MiscQuoteSideMenu.vue?vue&type=template&id=212547b4&scoped=true"
import script from "./MiscQuoteSideMenu.vue?vue&type=script&lang=js"
export * from "./MiscQuoteSideMenu.vue?vue&type=script&lang=js"
import style0 from "./MiscQuoteSideMenu.vue?vue&type=style&index=0&id=212547b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212547b4",
  null
  
)

export default component.exports